var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84298 3.3926L4.13674 0.268789C3.82476 -0.0911892 3.25279 -0.0895893 2.89041 0.273589L0.664946 2.50306C0.00258578 3.16622 -0.187003 4.15096 0.196174 4.94051C2.48533 9.6802 6.30784 13.5081 11.0443 15.8039C11.8331 16.187 12.817 15.9974 13.4794 15.3343L15.7256 13.084C16.0896 12.72 16.0904 12.1449 15.7272 11.8329L12.5914 9.14106C12.2635 8.85947 11.7539 8.89627 11.4251 9.22585L10.334 10.3186C10.2781 10.3771 10.2046 10.4157 10.1247 10.4284C10.0447 10.4412 9.96287 10.4273 9.89159 10.389C8.10806 9.36192 6.62858 7.88052 5.60385 6.09564C5.56547 6.02425 5.55158 5.94223 5.56429 5.86218C5.57701 5.78213 5.61564 5.70846 5.67425 5.65247L6.76218 4.56373C7.09176 4.23255 7.12776 3.72058 6.84298 3.3918V3.3926Z",
    fill: "#354152"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/media/phone.a28731cde424a7f67d0297e267ec01c4.svg";